import Vue from "vue";
import Message from "vue-m-message";
import "vue-m-message/dist/index.css";

Vue.use(Message);
